import styled from 'styled-components'
import PullToRefresh from 'react-simple-pull-to-refresh'

export const MyServicesContainer = styled.div<{ $isEmpty?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 5.5rem;
  ${({ $isEmpty }) => ($isEmpty ? 'flex: 1;  justify-content: space-between;' : '')}
`

export const MyServicesSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5.5rem;
`

export const ChipContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
  padding: 0 1rem;
`

export const ButtonContainer = styled.div<{ $hasScroll: boolean }>`
  position: fixed;
  bottom: 0;
  width: 100vw;
  align-self: center;
  padding: 1rem 1.25rem;
  background-color: var(--neutral-theme);
  box-shadow: none;
  ${({ $hasScroll }) =>
    $hasScroll ? 'border-top: 1px solid var(--gray200)' : 'border: 1px solid var(--neutral-theme);'}
`

export const UpdateScrollContainer = styled(PullToRefresh)`
  width: 100%;
  height: auto;
  flex: 1;
  min-height: 0;

  > .ptr__children {
    display: flex;
    flex-direction: column;
  }
`

export const RefreshIndicatorContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
`
